import PropTypes from 'prop-types';
import { FormControlLabel, Switch as MuiSwitch } from '@mui/material';

/**
 * Reusable Switch Component
 *
 * @param {String} label - Label text for the switch
 * @param {Boolean} checked - Checked state
 * @param {Function} onChange - Change handler
 * @param {String} color - Color of the switch (primary, secondary, etc.)
 * @param {Boolean} disabled - Whether the switch is disabled
 * @param {String} id - ID attribute for automation testing
 * @param {String} name - Name attribute for automation testing
 * @param {String} data-testid - Test ID attribute for automation testing
 * @param {Object} sx - Additional styling
 */
function Switch({
  label,
  checked,
  onChange,
  color = 'primary',
  disabled = false,
  id,
  name,
  'data-testid': dataTestId,
  sx = {}
}) {
  return (
    <FormControlLabel
      control={
        <MuiSwitch
          checked={checked}
          onChange={onChange}
          color={color}
          disabled={disabled}
          id={id}
          name={name}
          data-testid={dataTestId}
          inputProps={{
            id: id,
            name: name,
          }}
        />
      }
      label={label}
      sx={{
        display: 'flex',
        alignItems: 'center',
        ...sx,
      }}
    />
  );
}

Switch.propTypes = {
  label: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  color: PropTypes.string,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  name: PropTypes.string,
  'data-testid': PropTypes.string,
  sx: PropTypes.object,
};

export default Switch;
